import angular from 'angular';
import eventProductEntryComponent from './eventProductEntry.component';
import eventProductPage from '../../../lib/components/eventProductPage';
import translations from '../../../lib/translation';

const moduleName = 'staff.eventProductEntry';
let module = angular.module(moduleName, [
    translations,
    eventProductPage.name,
]);

module.component('eventProductEntry', eventProductEntryComponent);

export default module;
